import sendToA15 from "./A15";

const axiosMiddleware = {
  sendToA15,
};

export default axiosMiddleware;
